require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-the-bank-information-center-welcomes-the-launch-of.json") })
        }
      }, "path---en-us-update-the-bank-information-center-welcomes-the-launch-of");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-the-bank-information-center-welcomes-the-launch-of!./.cache/json/en-us-update-the-bank-information-center-welcomes-the-launch-of.json
// module id = 798
// module chunks = 231608221292675